import { ToastBody } from './_ToastBody';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { onPositionNotistack } from './_toastPosition';

/*
    🔥 TOAST — notistack

    ⚠️ POR QUÉ ESTE ARCHIVO ES MÁS LARGO QUE LOS OTROS

    El export suelto `enqueueSnackbar` no existe en todas las versiones
    de notistack (en la tuya tiraba "is not a function"). La forma que
    funciona SIEMPRE es tomar la función desde el hook, adentro del
    provider, y guardarla acá para poder llamarla desde afuera de React.
*/

let CLOSE = null;
let ENQUEUE = null;

const SnackbarBridge = () => {

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    ENQUEUE = enqueueSnackbar;
    CLOSE = closeSnackbar;

    return null;
};

export const AlertNotistackHost = ({ position }) => (

    <SnackbarProvider maxSnack={4} autoHideDuration={4000}
        anchorOrigin={onPositionNotistack(position)}
        classes={{ containerRoot: 'LStudio__app_toast_container' }} >
        <SnackbarBridge />
    </SnackbarProvider>
);

export const onNotifyNotistack = ({ type = 'info', title, text, autoClose }) => {

    if (!ENQUEUE) {
        console.warn('[Alerts] Notistack todavía no montó su Host. Revisá <AppAlertHost /> en App.js');
        return null;
    }

    return ENQUEUE(title, {
        autoHideDuration: autoClose || 4000,
        content: (key) => (
            <div className="LStudio__app_toast_wrap">
                <ToastBody type={type} title={title} text={text} onClose={() => CLOSE?.(key)} />
            </div>
        ),
    });
};
